import {
  googleMapsAndPlacesApiKey,
  googleRecaptchaSiteKey
} from './public/environment';

export const googleMapsApiSource = `https://maps.googleapis.com/maps/api/js?key=${googleMapsAndPlacesApiKey}&libraries=places&language=sv`;
export const googleRecaptchaSource = `https://www.google.com/recaptcha/api.js?render=${googleRecaptchaSiteKey}`;
